import React from "react";

function ImagePreview(props) {
  return (
    <div
      className="author-card-avatar"
      style={{
        width: "80px",
        height: "80px",
        overflow: "hidden",
        borderRadius: "12px",
        border: "2px solid rgba(0, 0, 0, 0.05)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        flexShrink: 0
      }}
    >
      <img
        src={props.url}
        alt="Preview"
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
}

export default ImagePreview;
